export class CooldownTracker {
  private attackCooldowns: Map<string, number> = new Map();
  private globalCooldownRemaining = 0;

  update(deltaTime: number): void {
    this.globalCooldownRemaining = Math.max(0, this.globalCooldownRemaining - deltaTime);

    for (const [attackId, remaining] of this.attackCooldowns.entries()) {
      const next = Math.max(0, remaining - deltaTime);
      if (next <= 0) {
        this.attackCooldowns.delete(attackId);
      } else {
        this.attackCooldowns.set(attackId, next);
      }
    }
  }

  startCooldown(attackId: string, duration: number): void {
    if (duration <= 0) return;
    this.attackCooldowns.set(attackId, duration);
  }

  startGlobalCooldown(duration: number): void {
    if (duration <= 0) return;
    this.globalCooldownRemaining = Math.max(this.globalCooldownRemaining, duration);
  }

  isOnCooldown(attackId: string): boolean {
    return (this.attackCooldowns.get(attackId) ?? 0) > 0;
  }

  isGlobalCooldownActive(): boolean {
    return this.globalCooldownRemaining > 0;
  }

  getRemainingCooldown(attackId: string): number {
    return this.attackCooldowns.get(attackId) ?? 0;
  }

  getGlobalRemaining(): number {
    return this.globalCooldownRemaining;
  }

  clear(): void {
    this.attackCooldowns.clear();
    this.globalCooldownRemaining = 0;
  }
}
